<template>
  <div class="w-full">
    <table v-if="groupBy === 'date'" id="blum-cumulative-table" class="w-full">
      <thead>
        <tr>
          <td><BlTextSubtitle2 text="Date mastered" /></td>
          <td><BlTextSubtitle2 text="Target" /></td>
          <td class="min-w-48">
            <BlTextSubtitle2 text="Date introduced" />
          </td>
          <td><BlTextSubtitle2 text="Curriculum" /></td>
        </tr>
      </thead>
      <tbody
        v-for="(targetBody, bodyIndex) in cumulativeTable"
        :key="bodyIndex"
      >
        <tr v-for="(target, index) in targetBody.targets" :key="index">
          <td
            v-if="index === 0"
            class="border-r bg-grey-100"
            :rowspan="targetBody.number_of_target"
          >
            <span class="flex items-center gap-2">
              <BlTextBody1
                :text="displayDate(targetBody.key)"
                class="text-grey-400"
              />
              <BlBubbleCount
                :count="
                  (bodyIndex > 0 ? '+' : '') + targetBody.number_of_target
                "
                class=""
              />
            </span>
          </td>
          <td>
            <BlTextBody1 :text="target.name" class="text-grey" />
          </td>
          <td>
            <BlTextBody1
              :text="displayDate(target.date_introduce)"
              class="text-grey-400"
            />
          </td>
          <td>
            <span class="flex gap-2">
              <div
                class="w-6 h-6 flex-shrink-0 rounded-full"
                :style="{ backgroundColor: target.curriculum_color }"
              />
              <BlTextBody1
                :text="target.curriculum_name"
                class="text-grey-400"
              />
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="groupBy === 'curriculum'" class="w-full space-y-4">
      <div
        id="cumulative-curriculum-header"
        class="grid grid-cols-8 gap-6 py-2 px-6 bg-grey-100 rounded"
      >
        <div class="col-span-4 text-grey-400 font-semibold">
          <BlTextSubtitle2 text="Target" />
        </div>
        <div class="col-span-2 text-grey-400 font-semibold">
          <BlTextSubtitle2 text="Date introduced" />
        </div>
        <div class="col-span-2 text-grey-400 font-semibold">
          <BlTextSubtitle2 text="Date mastered" />
        </div>
      </div>
      <div
        v-for="(targetBody, bodyIndex) in sortAlphabeticalTable"
        :key="bodyIndex"
        class="rounded border border-grey-200"
      >
        <div class="grid grid-cols-8 gap-6 py-4 px-6 border-b border-grey-200">
          <div class="flex gap-2 col-span-6">
            <div
              class="w-6 h-6 flex-shrink-0 rounded-full"
              :style="{
                backgroundColor: targetBody.targets.at(0).curriculum_color
              }"
            />
            <BlTextSubtitle2
              :text="targetBody.key"
              class="text-grey font-semibold"
            />
          </div>
          <div class="flex items-center gap-2 col-span-2">
            <div class="relative bg-light-purple-100 h-2 w-full rounded-full">
              <div
                class="aboslute bg-light-purple-300 h-2 rounded-full"
                :style="{
                  width:
                    (targetBody.number_of_mastered /
                      targetBody.number_of_target) *
                      100 +
                    '%'
                }"
              />
            </div>
            <div class="flex items-center gap-1">
              <BlBubbleCount :count="targetBody.number_of_mastered || 0" />
              <div>/</div>
              <BlBubbleCount
                type="secondary"
                :count="targetBody.number_of_target || 0"
              />
            </div>
          </div>
        </div>
        <div
          v-for="(target, index) in targetBody.targets"
          :key="index"
          class="grid grid-cols-8 gap-6 py-4 px-6"
        >
          <div class="flex gap-2 col-span-4">
            <BlTextBody1 :text="target.name" class="text-grey" />
            <div v-if="target.status !== 'mastered'" class="flex-shrink-0">
              <StatusChip :status="target.status" dense />
            </div>
          </div>
          <div class="col-span-2">
            <BlTextBody1
              :text="displayDate(target.date_introduce)"
              class="text-grey-400"
            />
          </div>
          <div class="col-span-2">
            <BlTextBody1
              :text="displayDate(target.date_mastered)"
              class="text-grey-400"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import BlBubbleCount from "../../BlBubbleCount.vue";
import BlTextSubtitle2 from "../../BlTextSubtitle2.vue";
import BlTextBody1 from "../../BlTextBody1.vue";
import StatusChip from "../target/StatusChip.vue";

export default {
  name: "CumulativeTablePreview",
  components: { BlBubbleCount, BlTextSubtitle2, BlTextBody1, StatusChip },
  props: ["groupBy"],
  computed: {
    ...mapGetters(["cumulativeTable"]),
    sortAlphabeticalTable() {
      const data = [...this.cumulativeTable];
      return data.sort(function(a, b) {
        if (a.key < b.key) return -1;
        if (a.key > b.key) return 1;
        return 0;
      });
    }
  },
  methods: {
    displayDate(date) {
      if (!date) return "-";
      return date
        .split("-")
        .reverse()
        .join("/");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/cumulativeGraph/TablePreview.vue